import { Code, Coffee, Database, FileSpreadsheet } from 'lucide-react';

export const freeCourses = [
    {
      id: 'fc1',
      title: "Java 8-17 New Features",
      category: 'free',
      level: "Intermediate",
      duration: "6 hours video",
      lectures: "20+",
      mode: "Self Recorded",
      language: "Hindi/English",
              certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
      banner: {
        title: 'Java 8-17',
        subtitle: 'New Features',
        background: 'bg-gradient-to-r from-red-600 to-orange-600',
        Icon: Coffee
      },
      description: "Learn the latest Java features from version 8 to 17 in this comprehensive free course.",
      overview: "Master modern Java programming with this free course covering all the new features introduced from Java 8 to Java 17, including Lambda expressions, Streams API, and more.",
      highlights: [
        "Most Premium Course",
        "Live & Recorded Classes",
        "Weekly Live Class for Doubt Solving",
        "50+ Assignments",
        "Assessment via Online Test",
        "Practical Approach",
        "Industry Recognised Certification Course",
        "Access to our Placement Portal"
      ],
      curriculum: [
          { 
            title: 'Part 1: Java 8 Features', 
            topics: [
              'Lambda Expressions',
              'Streams API',
              'Optional Class',
              'Default Methods'
            ] 
          },
          { 
            title: 'Part 2: Java 9-11 Features', 
            topics: [
              'Modules (JPMS)',
              'Local Variable Type Inference',
              'HTTP Client',
              'Collection Factory Methods'
            ] 
          },
          { 
            title: 'Part 3: Java 12-17 Features', 
            topics: [
              'Switch Expressions',
              'Text Blocks',
              'Records',
              'Pattern Matching'
            ] 
          }
      ]
    },
    {
      id: 'fc2',
      title: "OOPS C++",
      category: 'free',
      level: "Intermediate",
      duration: "5 hours video",
      lectures: "15+",
      mode: "Self Recorded",
      language: "Hindi/English",
              certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
      banner: {
        title: 'OOPS',
        subtitle: 'C++',
        background: 'bg-gradient-to-r from-blue-600 to-purple-600',
        Icon: Code
      },
      description: "Master Object-Oriented Programming concepts using C++ in this free course.",
      overview: "Learn Object-Oriented Programming fundamentals with C++ including classes, objects, inheritance, polymorphism, and encapsulation.",
      highlights: [
        "Most Premium Course",
        "Live & Recorded Classes",
        "Weekly Live Class for Doubt Solving",
        "50+ Assignments",
        "Assessment via Online Test",
        "Practical Approach",
        "Industry Recognised Certification Course",
        "Access to our Placement Portal"
      ],
      curriculum: [
          { 
            title: 'Part 1: Classes and Objects', 
            topics: [
              'Class Declaration',
              'Object Creation',
              'Constructors and Destructors',
              'Member Functions'
            ] 
          },
          { 
            title: 'Part 2: Inheritance and Polymorphism', 
            topics: [
              'Single and Multiple Inheritance',
              'Virtual Functions',
              'Abstract Classes',
              'Function Overriding'
            ] 
          },
          { 
            title: 'Part 3: Advanced OOP', 
            topics: [
              'Encapsulation',
              'Friend Functions',
              'Operator Overloading',
              'Templates'
            ] 
          }
      ]
    },
    {
      id: 'fc3',
      title: "Data Analysis Using MS Excel",
      category: 'free',
      level: "Beginner to Intermediate",
      duration: "4 hours video",
      lectures: "12+",
      mode: "Self Recorded",
      language: "Hindi/English",
              certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
      banner: {
        title: 'Data Analysis',
        subtitle: 'MS Excel',
        background: 'bg-gradient-to-r from-green-600 to-emerald-600',
        Icon: FileSpreadsheet
      },
      description: "Learn data analysis techniques using Microsoft Excel in this comprehensive free course.",
      overview: "Master Excel for data analysis including formulas, pivot tables, charts, and advanced functions for business intelligence.",
      highlights: [
        "Most Premium Course",
        "Live & Recorded Classes",
        "Weekly Live Class for Doubt Solving",
        "50+ Assignments",
        "Assessment via Online Test",
        "Practical Approach",
        "Industry Recognised Certification Course",
        "Access to our Placement Portal"
      ],
      curriculum: [
          { 
            title: 'Part 1: Excel Fundamentals', 
            topics: [
              'Basic Formulas and Functions',
              'Data Cleaning and Formatting',
              'Sorting and Filtering',
              'Conditional Formatting'
            ] 
          },
          { 
            title: 'Part 2: Advanced Excel', 
            topics: [
              'Pivot Tables and Pivot Charts',
              'VLOOKUP and INDEX-MATCH',
              'Data Validation',
              'What-If Analysis'
            ] 
          },
          { 
            title: 'Part 3: Data Analysis', 
            topics: [
              'Statistical Functions',
              'Charts and Graphs',
              'Dashboard Creation',
              'Data Storytelling'
            ] 
          }
      ]
    },
    {
      id: 'fc4',
      title: "MySQL",
      category: 'free',
      level: "Beginner to Intermediate",
      duration: "5 hours video",
      lectures: "18+",
      mode: "Self Recorded",
      language: "Hindi/English",
              certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
      banner: {
        title: 'MySQL',
        subtitle: 'Database',
        background: 'bg-gradient-to-r from-blue-700 to-indigo-800',
        Icon: Database
      },
      description: "Learn MySQL database management and SQL programming in this free course.",
      overview: "Master MySQL database design, SQL queries, and database administration through hands-on examples and real-world scenarios.",
      highlights: [
        "Most Premium Course",
        "Live & Recorded Classes",
        "Weekly Live Class for Doubt Solving",
        "50+ Assignments",
        "Assessment via Online Test",
        "Practical Approach",
        "Industry Recognised Certification Course",
        "Access to our Placement Portal"
      ],
      curriculum: [
          { 
            title: 'Part 1: MySQL Basics', 
            topics: [
              'Database Concepts',
              'MySQL Installation',
              'Basic SQL Commands',
              'Data Types and Constraints'
            ] 
          },
          { 
            title: 'Part 2: Advanced Queries', 
            topics: [
              'JOIN Operations',
              'Subqueries',
              'Aggregate Functions',
              'Group By and Having'
            ] 
          },
          { 
            title: 'Part 3: Database Management', 
            topics: [
              'Indexing and Performance',
              'User Management',
              'Backup and Recovery',
              'Database Security'
            ] 
          }
      ]
    }
]; 